import { render, staticRenderFns } from "./cost-average.vue?vue&type=template&id=519849ea&scoped=true&"
import script from "./cost-average.vue?vue&type=script&lang=js&"
export * from "./cost-average.vue?vue&type=script&lang=js&"
import style0 from "./cost-average.vue?vue&type=style&index=0&id=519849ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519849ea",
  null
  
)

export default component.exports